export default __webpack_public_path__ + "static/media/python.eea442b0.svg";